<template>
  <div class="home">
    <SaleOrderList v-show="listView" @newSales="onClickNewFromList" @editSales="onClickEditFromList" :scroll="corY" ref="refreshList"/>
    <SaleOrderForm v-show="formView" :order="order" @backClicked="onBackChild" @backReload="backReload" />
  </div>
</template>

<script>
// @ is an alias to /src
import axios from 'axios'
import SaleOrderList from '@/components/sales/SaleOrderList.vue'
import SaleOrderForm from '@/components/sales/SaleOrderForm.vue'
import { saleOrderUrl, getHeader } from '../config'
import { mapState } from 'vuex'

export default {
  name: 'SaleOrder',
  components: {
    SaleOrderList,
    SaleOrderForm
  },
  data () {
    return {
      corX: 0,
      corY: 0,
      listView: true,
      formView: false,
      order: {
        id: null,
        order_no: null,
        order_date: null,
        order_due_date: null,
        type_id: null,
        price_id: null,
        customer_no: null,
        customer: [{
          id: null,
          name: null,
          phone: null,
          address: null
        }],
        branch_no: null,
        branch: null,
        subtotal: '0',
        discount: '0',
        tax_id: null,
        tax: '0',
        total: '0',
        status: null,
        sale_no: null,
        salesman_id: null,
        salesman: null,
        surveyor_id: null,
        order_notes: null,
        survey_notes: null,
        project_name: null,
        term_no: null,
        term_notes: null,
        term_due_id: null,
        down_payment: '0',
        down_payment_date: null,
        details: [{
          id: null,
          order_no: null,
          order_date: null,
          branch_no: null,
          company_no: null,
          branch: null,
          product_no: null,
          product: null,
          description: null,
          qty: 0,
          qty_done: 0,
          serial_number: null,
          uom_id: null,
          uom_done_id: null,
          uomList: [{
            id: null,
            name: null,
            ratio: '0',
            category: null
          }],
          price: '0',
          tax_id: null,
          tax: '0',
          discount: '0',
          discount_percentage: '0',
          subtotal: '0',
          total: '0',
          queue: null,
          state: null,
          cost: '0',
          cost_id: null,
          product_sku: null,
          sec_serial_number: null
        }],
        qtys: [{
          id: null,
          customer_no: null,
          product_no: null,
          ref_no: null,
          qty: 0,
          uom_id: null,
          qty_date: null,
          queue: null,
          status: null,
          type: null,
          warehouse_no: null,
          company_no: null
        }],
        attachments: [{
          id: null,
          order_no: null,
          filename: null,
          url: null,
          extension: null,
          real_path: null,
          size: null,
          mime_type: null,
          upload_date: null,
          queue: null
        }],
        logs: [{
          id: null,
          log_date: null,
          ref_no: null,
          user_id: null,
          user: null,
          description: null
        }],
        expenses: [{
          order_no: null,
          amount: '0',
          description: 'Makan',
          type: 'biaya'
        }, {
          order_no: null,
          amount: '0',
          description: 'Penginapan',
          type: 'biaya'
        }, {
          order_no: null,
          amount: '0',
          description: 'Transport',
          type: 'biaya'
        }, {
          order_no: null,
          amount: '1',
          description: 'Man Power',
          type: 'term'
        }, {
          order_no: null,
          amount: '1',
          description: 'Working day',
          type: 'term'
        }],
        sales: [{
          id: null,
          sale_no: null,
          sale_date: null,
          sale_due_date: null,
          type_id: null,
          customer_no: null,
          branch_no: null,
          subtotal: null,
          tax_id: null,
          tax: '0',
          discount: '0',
          total: '0',
          delivery_cost: '0',
          deliver_no: null,
          status: null,
          warehouse_no: null,
          price_id: null,
          lock: false,
          company_no: null,
          term_due_id: null,
          salesman_id: null,
          order_no: null,
          details: [{
            id: null,
            sale_no: null,
            sale_date: null,
            branch_no: null,
            product_no: null,
            description: null,
            qty: '0',
            serial_number: null,
            uom_id: null,
            price: '0',
            tax_id: null,
            tax: null,
            discount: '0',
            discount_percentage: '0',
            subtotal: '0',
            total: '0',
            qty_done: '0',
            queue: null,
            warehouse_no: null,
            internal_code: null,
            cost: '0',
            cost_id: null,
            product_sku: null,
            sec_serial_number: null,
            company_no: null,
            customer_no: null
          }]
        }],
        lock: false,
        overdue: null
      }
    }
  },
  methods: {
    async backReload (id) {
      await axios.get(saleOrderUrl + '/' + id, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.onClickEditFromList(response.data.data)
        })
        .catch(error => {
          this.$swal(
            'Error!!!',
            error.response.data.message,
            'error'
          )
        })
    },
    onClickEditFromList: function (value) {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.listView = false
      this.formView = true
      this.order = value
    },
    getEditSales: function (value) {
      console.log(saleOrderUrl + '/' + value)
      axios.get(saleOrderUrl + '/' + value, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.listView = false
          this.formView = true
          this.order = response.data.data
        })
        .catch(error => {
          console.log(error.response)
        })
    },
    onClickNewFromList: function () {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      const date = new Date().toISOString()
      this.listView = false
      this.formView = true
      var details = []
      for (let i = 0; i < 10; i++) {
        var obj = {
          order_no: null,
          order_date: null,
          branch_no: null,
          branch: null,
          company_no: null,
          product_no: null,
          product: null,
          description: null,
          qty: '0',
          qty_done: '0',
          serial_number: null,
          uom_id: null,
          uom_done_id: null,
          uomList: [{
            id: null,
            name: null,
            ratio: '0',
            category: null
          }],
          price: '0',
          discount: '0',
          discount_percentage: '0',
          margin: '0',
          margin_percentage: '0',
          tax_id: null,
          tax: '0',
          subtotal: '0',
          total: '0',
          queue: null,
          state: null,
          cost: '0',
          cost_id: null,
          product_sku: null,
          sec_serial_number: null
        }
        details.push(obj)
      }
      var company = this.companyList.find(d => d.company_no === this.authUser.company_no)
      var taxid = company ? company.tax_id : null
      this.order = {
        id: null,
        order_no: null,
        order_date: date,
        order_due_date: null,
        type_id: null,
        price_id: 1,
        customer_no: null,
        customer: [{
          id: null,
          name: null,
          phone: null,
          address: null
        }],
        branch_no: this.authUser.branch_no,
        branch: null,
        subtotal: '0',
        discount: '0',
        discount_percentage: '0',
        tax_id: taxid,
        tax: '0',
        total: '0',
        status: null,
        sale_no: null,
        salesman_id: null,
        salesman: null,
        surveyor_id: null,
        order_notes: null,
        survey_notes: null,
        project_name: null,
        term_no: null,
        term_notes: null,
        margin: '0',
        term_due_id: 1,
        down_payment: '0',
        down_payment_date: null,
        company_no: this.authUser.company_no,
        details: details,
        attachments: [{
          id: null,
          order_no: null,
          filename: null,
          url: null,
          extension: null,
          real_path: null,
          size: null,
          mime_type: null,
          upload_date: null,
          queue: null
        }],
        qtys: [{
          id: null,
          customer_no: null,
          product_no: null,
          ref_no: null,
          qty: 0,
          uom_id: null,
          qty_date: null,
          queue: null,
          status: null,
          type: null,
          warehouse_no: null,
          company_no: null
        }],
        logs: [{
          id: null,
          log_date: null,
          ref_no: null,
          user_id: null,
          user: null,
          description: null
        }],
        expenses: [{
          order_no: null,
          amount: '0',
          description: 'Makan',
          type: 'biaya'
        }, {
          order_no: null,
          amount: '0',
          description: 'Penginapan',
          type: 'biaya'
        }, {
          order_no: null,
          amount: '0',
          description: 'Transport',
          type: 'biaya'
        }, {
          order_no: null,
          amount: '1',
          description: 'Man Power',
          type: 'term'
        }, {
          order_no: null,
          amount: '1',
          description: 'Working day',
          type: 'term'
        }],
        sales: [{
          id: null,
          sale_no: null,
          sale_date: null,
          sale_due_date: null,
          type_id: null,
          customer_no: null,
          branch_no: null,
          subtotal: null,
          tax_id: null,
          tax: '0',
          discount: '0',
          total: '0',
          delivery_cost: '0',
          deliver_no: null,
          status: null,
          warehouse_no: null,
          price_id: null,
          lock: false,
          company_no: null,
          term_due_id: null,
          salesman_id: null,
          order_no: null,
          details: [{
            id: null,
            sale_no: null,
            sale_date: null,
            branch_no: null,
            product_no: null,
            description: null,
            qty: '0',
            serial_number: null,
            uom_id: null,
            price: '0',
            tax_id: null,
            tax: null,
            discount: '0',
            discount_percentage: '0',
            subtotal: '0',
            total: '0',
            qty_done: '0',
            queue: null,
            warehouse_no: null,
            internal_code: null,
            cost: '0',
            cost_id: null,
            product_sku: null,
            sec_serial_number: null,
            company_no: null,
            customer_no: null
          }]
        }],
        lock: false,
        overdue: null,
        approve: null,
        approve_by: null,
        approve_date: null
      }
      this.$store.commit('SET_CUSTOMER_PLAFOND_AMOUNT', 0)
    },
    async onBackChild () {
      window.scrollTo(this.corX, this.corY)
      this.listView = true
      this.formView = false
      this.order = {
        id: null,
        order_no: null,
        order_date: null,
        order_due_date: null,
        type_id: null,
        price_id: '0',
        customer_no: null,
        customer: [{
          id: null,
          name: null,
          phone: null,
          address: null
        }],
        branch_no: null,
        company_no: null,
        branch: null,
        subtotal: '0',
        discount: '0',
        tax_id: null,
        tax: '0',
        total: '0',
        status: null,
        sale_no: null,
        salesman_id: null,
        salesman: null,
        surveyor_id: null,
        order_notes: null,
        survey_notes: null,
        term_no: null,
        term_notes: null,
        margin: '0',
        term_due_id: null,
        down_payment: '0',
        down_payment_date: null,
        details: [{
          id: null,
          order_no: null,
          order_date: null,
          branch_no: null,
          branch: null,
          company_no: null,
          product_no: null,
          product: null,
          description: null,
          qty: '0',
          qty_done: '0',
          serial_number: null,
          uom_id: null,
          uom_done_id: null,
          price: '0',
          discount: '0',
          discount_percentage: '0',
          margin: '0',
          margin_percentage: '0',
          tax_id: null,
          tax: '0',
          subtotal: '0',
          total: '0',
          queue: null,
          state: null,
          cost: '0',
          cost_id: null,
          product_sku: null,
          sec_serial_number: null,
          uomList: [{
            id: null,
            name: null,
            ratio: '0',
            category: null
          }]
        }],
        qtys: [{
          id: null,
          customer_no: null,
          product_no: null,
          ref_no: null,
          qty: 0,
          uom_id: null,
          qty_date: null,
          queue: null,
          status: null,
          type: null,
          warehouse_no: null,
          company_no: null
        }],
        attachments: [{
          id: null,
          order_no: null,
          filename: null,
          url: null,
          extension: null,
          real_path: null,
          size: null,
          mime_type: null,
          upload_date: null,
          queue: null
        }],
        logs: [{
          id: null,
          log_date: null,
          ref_no: null,
          user_id: null,
          user: null,
          description: null
        }],
        expenses: [{
          id: null,
          order_no: null,
          amount: '0',
          description: null,
          type: null
        }],
        sales: [{
          id: null,
          sale_no: null,
          sale_date: null,
          sale_due_date: null,
          type_id: null,
          customer_no: null,
          branch_no: null,
          subtotal: null,
          tax_id: null,
          tax: '0',
          discount: '0',
          total: '0',
          delivery_cost: '0',
          deliver_no: null,
          status: null,
          warehouse_no: null,
          price_id: null,
          lock: false,
          company_no: null,
          term_due_id: null,
          salesman_id: null,
          order_no: null,
          details: [{
            id: null,
            sale_no: null,
            sale_date: null,
            branch_no: null,
            product_no: null,
            description: null,
            qty: '0',
            serial_number: null,
            uom_id: null,
            price: '0',
            tax_id: null,
            tax: null,
            discount: '0',
            discount_percentage: '0',
            subtotal: '0',
            total: '0',
            qty_done: '0',
            queue: null,
            warehouse_no: null,
            internal_code: null,
            cost: '0',
            cost_id: null,
            product_sku: null,
            sec_serial_number: null,
            company_no: null,
            customer_no: null
          }]
        }],
        lock: false,
        overdue: null,
        approve: null,
        approve_by: null,
        approve_date: null
      }
      this.$refs.refreshList.refreshSales()
    }
  },
  computed: {
    ...mapState({
      authUser: state => state.users.authUser,
      companyList: state => state.companies.companyList,
      taxList: state => state.taxes.taxList
    })
  },
  mounted () {
    this.$store.dispatch('getCompanyList')
    this.$store.dispatch('getCustomerListLite')
    this.$store.dispatch('getTermDueList')
    this.$store.dispatch('getPriceListGroup')
    this.$store.dispatch('getSalesTypeList')
    this.$store.dispatch('getBranchList')
    this.$store.dispatch('getTaxList')
    this.$store.dispatch('getUomList')
    this.$store.dispatch('getRowTable')
    this.$store.dispatch('getWarehouseList')
    this.$store.dispatch('getUserAll')
    this.$store.dispatch('getProductTemplateList')
    this.$store.dispatch('getSalesTermConditions')
    this.$store.dispatch('getEmployeeList')
    // customer state
    this.$store.dispatch('getStateList')
    this.$store.dispatch('getCityList')
    this.$store.dispatch('getAreaList')
    this.$store.dispatch('getCustomerGroupList')
    this.$store.dispatch('getCustomerRating')
    this.$store.dispatch('getSettingList')
    // const payload = {
    //   date: new Date().toISOString()
    // }
    // this.$store.dispatch('getProductWithTotal', payload)
    // get query param from url
    // var form = this.$route.query.form
    var salesParam = this.$route.query.refno
    if (typeof salesParam !== 'undefined') {
      this.getEditSales(salesParam)
    }
  }
}
</script>
